import { useEffect, useRef } from 'react';
import { useUnsavedChanges } from './UnsavedChangesProvider';
export const useTrackUnsavedChanges = (value) => {
    const { setHasUnsavedChanges } = useUnsavedChanges();
    const prevValue = useRef(value);
    useEffect(() => {
        const hasChanged = !!value;
        if (prevValue.current !== hasChanged) {
            setHasUnsavedChanges(hasChanged);
            prevValue.current = hasChanged;
        }
        return () => {
            setHasUnsavedChanges(false);
        };
    }, [value, setHasUnsavedChanges]);
};
